import { SET_TOTAL, UPDATE_CONTACTS, DELETE_SURVEY_ANSWER_T2, UPDATE_SURVEY_ANSWER_T2, UPDATE_REASON, UPDATE_ANSWERS, UPDATE_USER_INFO, UPDATE_SURVEY_ANSWERS, REMOVE_SURVEY_ANSWER, SET_SURVEY_RESPONSE } from './types'


export const updateAnswers = (payload) => {
    return {
        type: UPDATE_ANSWERS,
        payload: payload
    }
}

export const updateContacts = (payload) => {
    return {
        type: UPDATE_CONTACTS,
        payload: payload
    }
}

export const updateReason = (payload) => {
    return {
        type: UPDATE_REASON,
        payload: payload
    }
}

export const updateUserInfo = (payload) => {
    return {
        type: UPDATE_USER_INFO,
        payload: payload
    }
}

export const updateSurveyAnswersT2 = (payload) => {
    return {
        type: UPDATE_SURVEY_ANSWER_T2,
        payload: payload
    }
}

export const updateSurveyAnswers = (payload) => {
    return {
        type: UPDATE_SURVEY_ANSWERS,
        payload: payload
    }
}

export const deleteSurveyAnswersT2 = (payload) => {
    return {
        type: DELETE_SURVEY_ANSWER_T2,
        payload: payload
    }
}

export const removeSurveyAnswer = (payload) => {
    return {
        type: REMOVE_SURVEY_ANSWER,
        payload: payload
    }
}

export const setSurveyResponse = (payload) => {
    return {
        type: SET_SURVEY_RESPONSE,
        payload: payload
    }
}

export const setBusinessTotal = (payload) => {
    return {
        type: SET_TOTAL,
        payload: payload
    }
}

